export default __webpack_public_path__ + "images/38c3bafcde091e3473d551f80b8899a6.png";